import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    scrollbar: 0,
  },
  mutations: {
    SetScrollbar(state, n) {
      state.scrollbar = n;
    }
  }
})